import React, { useState } from 'react';
import { connect } from 'react-redux';

// components
import Link from 'src/universal/components/Link';
import CollapseToggleButton from './CollapseToggleButton';

// utils and selectors
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import svgFetcher from 'acq-components/lib/utils/svgFetcher';
import clsx from 'clsx';
import { getCardColorInfoList } from 'src/universal/redux/cardColors';
import { decideCardArtUrl } from 'src/universal/utils/cardColorChoices';

// styles
import './styles.scss';

const CardTray = ({
  className,
  cardList = [null, null, null],
  actionButtonLabel,
  actionButtonLink,
  onActionButtonClick = () => {},
  onRemoveIconClick = () => {},
  onEmptyCardClick = () => {},
  colorInfoList
}) => {
  const [caratDirection, setCaratDirection] = useState('down');

  const componentClassName = 'aexp-card-tray';
  const supportedCount = 3;

  const ensureItemCount = cardList => {
    const incomingCount = cardList.length;
    if (incomingCount < supportedCount) {
      for (let i = incomingCount; i <= supportedCount; i++) {
        cardList.push(null);
      }
    }

    return cardList;
  };

  const onMainActionButtonClick = () => {
    onActionButtonClick();
  };

  const createOnRemoveItemClickHandler = cardObj => () => onRemoveIconClick(cardObj);

  const createOnEmptyCardClickHandler = index => () => onEmptyCardClick(index);

  const itemList = ensureItemCount(cardList);

  return (
    <div
      className={clsx(
        componentClassName,
        className ? ' ' + className : '',
        caratDirection
      )}
      id="compare-tray"
    >
      <ul className="item-list">
        <CollapseToggleButton
          caratDirection={caratDirection}
          setCaratDirection={setCaratDirection}
        />
        {itemList.map((model, index) => {
          if (model) {
            const removeIconElement = svgFetcher('dls-icon-cancel-circle', 'dls');
            const colorInfo = colorInfoList.find(
              c => c.shortName === model.shortName
            );
            const cardArtUrl = decideCardArtUrl(
              model.appAssets.cardArt,
              colorInfo,
              model.shortName
            );
            const iconWrapElement = (
              <button
                className="icon-wrap"
                onClick={createOnRemoveItemClickHandler(model)}
                aria-label="remove card from compare tray"
              >
                <span className="svg-resource">{removeIconElement}</span>
              </button>
            );
            return (
              <li
                key={'key_' + index}
                className={clsx('item-unit', { noImg: cardArtUrl === '' })}
              >
                {cardArtUrl !== '' && (
                  <img src={cardArtUrl} alt={model.cardArtAltText} />
                )}
                {iconWrapElement}
              </li>
            );
          } else {
            const addIconElement = svgFetcher('dls-icon-plus-circle-filled', 'dls');
            return (
              <li
                key={'key_' + index}
                className="item-unit empty"
                onClick={createOnEmptyCardClickHandler(index)}
              >
                <span className="svg-resource icon-wrap">{addIconElement}</span>
              </li>
            );
          }
        })}
      </ul>
      {actionButtonLink ? (
        <Link
          className="action-button"
          to={actionButtonLink}
          onClick={onMainActionButtonClick}
          text={actionButtonLabel}
        />
      ) : (
        <React.Fragment>
          <button className="action-button" onClick={onMainActionButtonClick}>
            <Sanitizer safelySetInnerHTML={actionButtonLabel} />
          </button>
        </React.Fragment>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  colorInfoList: getCardColorInfoList(state)
});

export default connect(mapStateToProps)(CardTray);
